import React, { useEffect, useMemo, useState } from "react";
import { FlightSearch, Modal } from "../../../../../Components";
import { FiArrowRight } from "react-icons/fi";
import { CHECKIN_URLS } from "../../../../../Utils/constants";
import { FaHistory } from "react-icons/fa";
import moment from "moment";
import { getRecentFlightSearches } from "../../../../../Utils/recentSearches";

function FlightHome() {
	const [ShowLinks, setShowLinks] = useState(false);
	const [QuickSelection, setQuickSelection] = useState(null);
	const [RecentSearches, setRecentSearches] = useState([]);

	useEffect(() => {
		let mounted = true;
		getRecentFlightSearches().then((searches) => {
			if (mounted) {
				setRecentSearches(searches);
			}
		});
		return () => {
			mounted = false;
		};
	}, []);

	const quickSearchProps = useMemo(
		() => ({
			from: QuickSelection?.from,
			to: QuickSelection?.to,
			date: QuickSelection?.date,
			range: QuickSelection?.range,
			passengers: QuickSelection?.passengers,
			cabinClass: QuickSelection?.cabinClass,
			mode: QuickSelection?.mode,
			optimizee: QuickSelection?.optimize,
		}),
		[QuickSelection]
	);

	const formatTripDates = (search) => {
		if (search?.mode?.value === "round" && search?.range?.startDate && search?.range?.endDate) {
			return `${moment(search.range.startDate).format("DD MMM")} - ${moment(search.range.endDate).format("DD MMM")}`;
		}
		if (search?.date) {
			return moment(search.date).format("DD MMM YYYY");
		}
		return "Flexible dates";
	};

	const formatPassengers = (search) => {
		const passengers = search?.passengers || {};
		const parts = [];
		if (passengers.adult) parts.push(`${passengers.adult} Adult`);
		if (passengers.child) parts.push(`${passengers.child} Child`);
		if (passengers.infant) parts.push(`${passengers.infant} Infant`);
		return parts.join(", ") || "1 Adult";
	};

	return (
		<>
			<div className="p-3 md:p-4">
				<FlightSearch key={QuickSelection?.signature || "default-flight-search"} {...quickSearchProps} />
				{RecentSearches.length > 0 && (
					<div className="my-6">
						<div className="mb-3 text-sm align-center whitespace-nowrap">
							<FaHistory className="mr-1" />
							Recent Searches
						</div>
						<div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
							{RecentSearches.slice(0, 4).map((search, index) => {
								const fromCode = search?.from?.airportCode || "";
								const toCode = search?.to?.airportCode || "";
								const tripLabel = search?.mode?.label || "Trip";
								return (
									<button
										type="button"
										onClick={() => setQuickSelection(search)}
										key={`${search.signature || search.label}-${index}`}
										className="p-3 text-left border shadow-sm rounded-xl bg-canvas hover:bg-light transition-colors min-w-0"
									>
										<div className="flex items-start justify-between gap-2">
											<div className="text-[11px] uppercase tracking-wide text-secondary truncate">{tripLabel}</div>
											<div className="text-[11px] text-secondary shrink-0 truncate">{search?.cabinClass?.label || "Cabin"}</div>
										</div>
										<div className="mt-2 text-sm font-semibold leading-5 truncate uppercase">
											{fromCode} to {toCode}
										</div>
										<div className="mt-2 text-[11px] leading-4 text-secondary">
											<div className="truncate">{formatTripDates(search)}</div>
											<div className="truncate">{formatPassengers(search)}</div>
										</div>
									</button>
								);
							})}
						</div>
					</div>
				)}

				<div className="my-6">
					<h3>Traveling today</h3>
					<div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
						<div onClick={() => setShowLinks(true)} className="p-4 md:p-6 border shadow-sm cursor-pointer rounded-xl bg-canvas hover:bg-light">
							<h1 className="text-2xl font-normal">Web Check-in</h1>
							<div className="max-w-xl mt-2 text-sm text-secondary">Easily go to airline website for check-in</div>
							<FiArrowRight className="mt-2 text-2xl" />
						</div>
					</div>
				</div>
			</div>
			<video className="absolute bottom-0 left-0 object-cover w-full h-full -z-10" autoPlay muted loop>
				<source src="https://cdn.travelwings.com/assets/corp/videos/clouds.mp4" type="video/mp4" />
			</video>
			<div className="absolute top-0 bottom-0 left-0 right-0 w-full h-full -z-10" style={{ background: "linear-gradient(to bottom, rgba(255,255,255,1) 70%,rgba(255,255,255,0) 100%)" }} />
			<div className="absolute top-0 bottom-0 left-0 right-0 w-full h-full -z-10" style={{ background: "linear-gradient(to right, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 20%)" }} />
			<div className="absolute top-0 bottom-0 left-0 right-0 w-full h-full -z-10" style={{ background: "linear-gradient(to left, rgba(255,255,255,1) 0%,rgba(255,255,255,0) 20%)" }} />

			<Modal open={ShowLinks} onClose={() => setShowLinks(false)}>
				<div className="p-3 md:p-4">
					<h3 className="text-center my-4">Web Check-In</h3>
					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[80vh] overflow-y-auto pr-3">
						{CHECKIN_URLS.map((airline, i) => {
							console.log(airline);
							return (
								<div onClick={() => window.open(airline.url, "_blank")} key={i} className="p-4 border rounded-lg cursor-pointer flex-center hover:bg-light">
									<div>
										<img src={`https://cdn.travelwings.com/globalassets/images/${airline.value}.jpg`} alt={airline.label} className="w-10 h-10 m-auto rounded-full" />
										<div className="mt-4 text-xs text-center">{airline.label}</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</Modal>
		</>
	);
}

export default FlightHome;
